import angular from 'angular';
import productLabelPreviewComponent from './product-label-preview.component';

export default angular.module('common.components.productLabelPreview', [])
  .component('productLabelPreview', productLabelPreviewComponent)
  .name;



// WEBPACK FOOTER //
// ./components/app/products/product-label-preview/product-label-preview.module.js